<div class="container">
  <div>
    <div class="header-container">
      <h1 class="card-body-header">{{ cardHeader$ | async }}</h1>
      <div *ngIf="componentName$ | async as componentName">
        <ng-container [ngSwitch]="componentName">
          <div *ngSwitchCase="'list'">
            <dxo-button
              [primary]="true"
              text="Add new employee"
              data-category="list"
              data-action="Close Modal"
              (handleClick)="goAdd()"
            >
            </dxo-button>
          </div>

          <div *ngSwitchCase="'add'">
            <div>
              <dxo-button
                [primary]="true"
                text="Search employees"
                data-category="list"
                data-action="Close Modal"
                (handleClick)="goList()"
              >
              </dxo-button>
            </div>
          </div>

          <div *ngSwitchCase="'detail'">
            <div class="details-buttons">
              <div class="back-button">
                <dxo-button
                  text="<&nbsp;&nbsp;Back to search employees"
                  data-category="list"
                  data-action="Close Modal"
                  (handleClick)="goList()"
                >
                </dxo-button>
              </div>
              <dxo-button [primary]="true" text="Edit employee"> </dxo-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="componentName$ | async as componentName">
    <ng-container [ngSwitch]="componentName">
      <div *ngSwitchCase="'list'">
        <app-employees #listForm></app-employees>
      </div>

      <div *ngSwitchCase="'add'">
        <div>
          <app-add-employee #addForm></app-add-employee>
        </div>
      </div>

      <div *ngSwitchCase="'detail'">
        <div>
          <app-employee-detail #detailForm></app-employee-detail>
        </div>
      </div>
    </ng-container>
  </div>
</div>
